module.exports = __webpack_public_path__ + "static/img/yvwu.f6c890c6.svg";